module.exports = __webpack_public_path__ + "static/media/breastcancer.bfd38938.svg";